<template>
    <div class="documents">
        <div class="seccion-1">
            <div class="pending">
                <h3>Solicitudes pendientes</h3>
                <center v-infinite-scroll="loadMore" infinite-scroll-disabled="busy" infinite-scroll-distance="100">
                    <div>
                        <label><div>Fecha</div></label>
                        <label><div>Solicitud</div></label>
                        <label><div>Modelo</div></label>
                        <label><div>Foto</div></label>
                        <label><div>Aprobar</div></label>
                        <label><div>Rechazar</div></label>
                    </div>
                    <div v-for="(item, index) in pending" :key="index">
                        <label><div>{{item.created_at.split($store.state.constants.SEPARETOR)[0]}}</div></label>
                        <label><div>{{item.id}}</div></label>
                        <label><div>{{item.stagename}}</div></label>
                        <label><div @click="photoModal(item.photo)">ver foto</div></label>
                        <label>
                            <div><button @click="aprobarPicture(item.id)">Aprobar</button></div>
                        </label>
                        <label>
                            <div><button @click="rechazarPicture(item.id)">Rechazar</button></div>
                        </label>
                    </div>
                </center>
            </div>
        </div>
    </div>
</template>

<script>
import API from '@/api'
import Notify from '@/utils/Notification.js'

export default {
    name: 'picture',
    data() {
        return {
            pending: [],
            item: null,
            cant: null,
            date: null,
            limit: 9,
            offset: 0,
            busy: false,
            listEnd: false,
            itemFlag: false
        }
    },
    beforeMount() {
        this.$root.$emit('solicitud', this.$route.name)
    },
    methods: {
        loadMore() {
            this.busy = true
            if (!this.listEnd) {
                setTimeout(() => {
                    if (this.pending.length < this.offset) {
                        this.listEnd = true
                        return
                    }
                    if (this.itemFlag) {
                        this.getPendingPictures()
                        this.busy = false
                    } else {
                        this.loadMore()
                    }
                }, 1000)
            }
        },
        aprobarPicture(id) {
            API.aprobarPicture(id)
                .then((res) => {
                    this.limit = 9
                    this.offset = 0
                    this.busy = false
                    this.listEnd = false
                    this.itemFlag = false
                    this.pending = []
                    this.getPendingPictures()
                    Notify('dirty', 'La solicitud de producto se ha actualizado con exito')
                })
        },
        rechazarPicture(id) {
            API.removeSolicitdPicture(id)
                .then((res) => {
                    this.limit = 9
                    this.offset = 0
                    this.busy = false
                    this.listEnd = false
                    this.itemFlag = false
                    this.pending = []
                    this.getPendingPictures()
                    Notify('dirty', 'La solicitud de producto se ha actualizado con exito')
                })
        },
        getPendingPictures() {
            API.getPendingPictures(this.limit, this.offset)
                .then((res) => {
                    res.map(item => { this.pending.push(item) })
                    this.offset += this.limit
                    this.itemFlag = true
                })
        }
    },
    mounted() {
        this.getPendingPictures()
    }
}
</script>

<style scoped>
    .documents {
        display: flex;
        background-color: #cdcdcd;
        width: 100%;
    }
    .documents > .seccion-1 {
        width: 100%;
        height: 78vh;
        padding: 20px;
    }
    .documents > .seccion-2 {
        width: 40%;
        height: 78vh;
        padding: 20px;
    }
    .documents > div > .pending {
        background-color: #8363b7;
        width: 100%;
        height: 100%;
        border-radius: 20px;
        border-style: outset;
    }
    .documents > div > .approved {
        background-color: #585858;
        width: 100%;
        height: 100%;
        border-radius: 20px;
        border-style: outset;
    }
    .documents > div > div > h3 {
        color: #fff;
        font-weight: bold;
        padding-bottom: 0px;
        padding-top: 30px;
        text-align: center;
    }
    .documents > div > div > center {
        height: 80%;
        overflow-y: auto;
    }
    .documents > div > div > center > div {
        background: #2b2926;
        margin: 20px;
        color: #fff;
        border-radius: 20px;
        height: 60px;
        position: relative;
    }
    .documents > .seccion-1 > div > center > div > label{
        width: 13%;
        position: relative;
        height: 100%;
    }
    .documents > .seccion-2 > div > center > div > label{
        width: 15%;
        position: relative;
        height: 100%;
    }
    .documents > div > div > center > div > label > div{
        width: 100%;
        position: absolute;
        left: 50%;
        bottom: 0;
        transform: translate(-50%,-50%);
    }
    .documents > div > div > center > div > label > div > button{
        background-color: #e0b059;
        color: #fff;
        border-radius: 30px;
        font-weight: bold;
    }
    .info-wrapper > div {
        display: grid;
        padding: 20px;
    }
    .info-wrapper > div > label {
        font-weight: bold;
    }
    .info-wrapper > div > input {
        width: 250px;
        height: 40px;
        text-align: center;
        border-radius: 15px;
    }
    .info-wrapper > button {
        background-color: #e0b059;
        color: #fff;
        width: 150px;
        height: 60px;
        border-radius: 30px;
    }
</style>



// WEBPACK FOOTER //
// src/components/Solicitudes/Picture.vue